import      React 
  from 'react';
import {    RadarGraphStacked,
            LineGraphStacked,
            LineGraph,
            BarGraphStacked,
} from '../../components/graphs';

export const GraphsPage: React.FC = () => {
    return (<div style={{
        height: "600px",
        width: "600px",
    }}>
    
    <RadarGraphStacked
        data={[
            {   subject: 'Math',
                scaledValues: [
                    { min: 0, max: 100, value: 98, scaleType: "linear" },
                ],
            },
            {   subject: 'Chinese', 
                scaledValues: [
                    { min: 0, max: 100, value: 42, scaleType: "linear" },
                ],
            },
            {   subject: 'English', 
                scaledValues: [
                    { min: 0, max: 100, value: 78, scaleType: "linear" },
                ],
            },
            {   subject: 'Geography', 
                scaledValues: [
                    { min: 0, max: 100, value: 68, scaleType: "linear" },
                ],
            },
            {   subject: 'Physics', 
                scaledValues: [
                    { min: 0, max: 100, value: 48, scaleType: "linear" },
                ],
            },
            {   subject: 'History', 
                scaledValues: [
                    { min: 0, max: 100, value: 24, scaleType: "linear" },
                ],
            },
        ]}
    />

    {/* <LineGraphStacked
        data={[
            { x: 0, y: [10, 30]},
            { x: 1, y: [20, 40]},
            { x: 2, y: [30, 50]},
            { x: 3, y: [40, 60]},
            { x: 4, y: [50, 70]},
            { x: 5, y: [60, 90]},
            { x: 6, y: [70, 110]},
            { x: 7, y: [80, 120]},
            { x: 8, y: [90, 100]},
            { x: 9, y: [100, 130]},
        ]}
    /> */}

    {/* <BarGraphStacked
        data={[ 
            { x: 0, y: [10, 30]},
            { x: 1, y: [20, 40]},
            { x: 2, y: [30, 50]},
            { x: 3, y: [40, 60]},
            { x: 4, y: [50, 70]},
            { x: 5, y: [60, 90]},
            { x: 6, y: [70, 110]},
            { x: 7, y: [80, 120]},
            { x: 8, y: [90, 100]},
            { x: 9, y: [100, 130]},
        ]}
    /> */}
    
    </div>);
}